import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    add: 'Create a quote',
    presets: 'Invoicing settings',
    searchbar: 'Search by quote number or title, client name... ',
    statuses: {
      accepted: 'Accepted',
      archived: 'Declined',
      'not-sent': 'Draft',
      sent: 'Sent',
    },
    title: 'Quotes',
  },
  fr: {
    add: 'Créer un devis',
    presets: 'Paramètres de facturation',
    searchbar: 'Recherche par numéro ou titre de devis, client·e...',
    statuses: {
      accepted: 'Acceptés',
      archived: 'Refusés',
      'not-sent': 'Brouillon',
      sent: 'Envoyés',
    },
    title: 'Devis',
  },
} as const);

export default locales;
